<div class="orchestrator" msOrchestratorContainer="any" [msOrchestratorContext]="orchestratorContext">
  <div class="outer-box" msOrchestratorBlock="outerBox">
    <div class="block-wrapper" msOrchestratorBlock="blockWrapper">
      <div class="block-parent">
        <ng-content select="ms-speed-reading-result-block"></ng-content>
      </div>
    </div>
    <div class="button-container" msOrchestratorBlock="buttonContainer">
      <ng-content select="ms-speed-reading-result-button, [ms-speed-reading-result-button]"></ng-content>
    </div>
  </div>
</div>
